import { Box, Flex, Text } from '@chakra-ui/react';
import { LightningIcon } from '@udacity/chakra-uds-icons';

import { FLASH_SALE_EYEBROW } from '../constants';

/**
 * Catalog flash-sale eyebrow (Figma 796:31649): a cyan-bordered pill — lightning glyph + uppercase
 * "FLASH SALE" in Barlow Condensed — followed by a thin translucent divider line that fills the
 * remaining width. Shared by both catalog surfaces (the `ab_plp_redesign_2025` hero card and the
 * legacy `CatalogValuePropsHeroSection` banner) so they stay identical. The homepage/`/experience`
 * flash surfaces intentionally use a borderless eyebrow, so they do NOT use this component.
 *
 * Both the border AND the divider are a soft, translucent Cyan-100 (#E1F8FF) hairline at ~25% opacity
 * — NOT a flat full-strength `#89e6ff`. Pixel-sampling node 796:31651/796:31655 over the dark bg reads
 * uniform `rgb(~62,64,64)`, which is `#E1F8FF` at α≈0.25 (the raw `#89e6ff` hex in the design context is
 * misleading; `get_variable_defs` binds Cyan-100). The chip also carries generous internal padding: in
 * the 68×19 node raster the glyph is only ~8px tall (rows 5–12), leaving ~5–6px vertical / ~9px
 * horizontal breathing room, so the icon/text never hug the border.
 */
export function FlashSalePillEyebrow() {
  return (
    <Flex alignItems='center' gap='7px' width='100%'>
      <Flex
        alignItems='center'
        border='1px solid'
        borderColor='rgba(225, 248, 255, 0.25)'
        borderRadius='3px'
        boxShadow='0px 1px 1px rgba(0, 0, 0, 0.25)'
        color='white'
        flexShrink={0}
        gap='6px'
        paddingX='10px'
        paddingY='6px'
      >
        <LightningIcon height='14px' width='14px' />
        <Text
          fontFamily='condensed'
          fontSize='0.8125rem'
          fontWeight='500'
          letterSpacing='0.1em'
          lineHeight={1}
          textTransform='uppercase'
          whiteSpace='nowrap'
        >
          {FLASH_SALE_EYEBROW}
        </Text>
      </Flex>
      <Box backgroundColor='rgba(225, 248, 255, 0.25)' flex={1} height='1px' />
    </Flex>
  );
}
